import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-lesotho-affordability-home-loan.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorLesothoAffordabilityHomeLoan = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorLesothoAffordabilityHomeLoan, _super);
    function CalculatorLesothoAffordabilityHomeLoan(element) {
        return _super.call(this, element) || this;
    }
    CalculatorLesothoAffordabilityHomeLoan.prototype.init = function () {
        this.inputMonthlyIncome = this.element.querySelector('input[name=monthly_income]');
        this.inputExpenses = this.element.querySelector('input[name=monthly_expenses]');
        this.inputTerm = this.element.querySelector('input[name=term_months]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.totalPurchasePrice = this.element.querySelector('.js-purchase-price');
        this.totalMonthlyRepayment = this.element.querySelector('.js-monthly-repayment');
        this.totalMonthsDisplay = this.element.querySelector('.js-term-months');
        this.interestRateDisplay = this.element.querySelector('.js-interest-rate');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.buttonTermsAndConditions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-lesotho-affordability-home-loan__result--terms');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndConditions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndConditions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        this.calculate();
        TooltipsService.initTooltips();
    };
    CalculatorLesothoAffordabilityHomeLoan.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function () {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function () {
            _this.totalMonthlyRepayment.innerHTML = "-";
            _this.totalPurchasePrice.innerHTML = "-";
            _this.interestRateDisplay.innerHTML = "-";
            _this.totalMonthsDisplay.innerHTML = "-";
        });
    };
    CalculatorLesothoAffordabilityHomeLoan.prototype.calculate = function () {
        var income = parseFloat(this.inputMonthlyIncome.value);
        var expenses = parseFloat(this.inputExpenses.value);
        var term = parseFloat(this.inputTerm.value);
        var interestRate = parseFloat(this.inputInterest.value);
        if (!income || !term || !interestRate)
            return;
        var monthlyRate = interestRate / 12 / 100;
        // DNQF check
        if (expenses >= income) {
            this.totalPurchasePrice.innerHTML = "DNQF";
            this.totalMonthlyRepayment.innerHTML = "-";
            this.interestRateDisplay.innerHTML = "-";
            this.totalMonthsDisplay.innerHTML = "-";
            return;
        }
        // 60% rule
        var maxInstalment = income * 0.6;
        // Actual usable instalment after expenses
        var monthlyPayment = maxInstalment - expenses;
        if (monthlyPayment <= 0) {
            this.totalPurchasePrice.innerHTML = "DNQF";
            this.totalMonthlyRepayment.innerHTML = "-";
            this.interestRateDisplay.innerHTML = "-";
            this.totalMonthsDisplay.innerHTML = "-";
            return;
        }
        // Loan amount from fixed payment
        var loanAmount = monthlyPayment *
            ((1 - Math.pow(1 + monthlyRate, -term)) / monthlyRate);
        // Format
        var formattedLoanAmount = this.roundFormatter(loanAmount, 2, true);
        var formattedMonthly = this.roundFormatter(monthlyPayment, 2, true);
        // UI
        this.totalPurchasePrice.innerHTML = formattedLoanAmount;
        this.totalMonthlyRepayment.innerHTML = income * 0.6;
        this.interestRateDisplay.innerHTML = interestRate.toFixed(2) + "%";
        this.totalMonthsDisplay.innerHTML = term + " months";
    };
    CalculatorLesothoAffordabilityHomeLoan.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var rounded = expr.toFixed(decplaces);
        var _a = rounded.split('.'), intPart = _a[0], decPart = _a[1];
        if (formatted) {
            intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        return decplaces > 0 ? intPart + "." + decPart : intPart;
    };
    // PMT function remains for reuse or other calculators
    CalculatorLesothoAffordabilityHomeLoan.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate === 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type === 1) {
            pmt /= (1 + rate);
        }
        return pmt;
    };
    return CalculatorLesothoAffordabilityHomeLoan;
}(Base));
export { CalculatorLesothoAffordabilityHomeLoan };
// export class CalculatorBotswanaAffordabilityHomeLoan {
// 	// Shared Elements
// 	element: Element;
// 	// Affordability inputs
// 	inputMonthlyIncome: HTMLInputElement | null;
// 	inputExpenses: HTMLInputElement | null;
// 	inputTermAffordability: HTMLInputElement | null;
// 	inputInterestAffordability: HTMLInputElement | null;
// 	// Repayment inputs
// 	inputPurchasePrice: HTMLInputElement | null;
// 	inputDeposit: HTMLInputElement | null;
// 	inputTermRepayment: HTMLInputElement | null;
// 	inputInterestRepayment: HTMLInputElement | null;
// 	// Shared Outputs
// 	totalMonthlyRepayment: HTMLElement | null;
// 	termMonthsDisplay: HTMLElement | null;
// 	interestRateDisplay: HTMLElement | null;
// 	// Specific Outputs
// 	totalPurchasePrice: HTMLElement | null; // affordability
// 	totalInterest: HTMLElement | null; // repayment
// 	// Buttons
// 	buttonCalculate: HTMLButtonElement | null;
// 	buttonReset: HTMLButtonElement | null;
// 	// Flags
// 	isAffordabilityMode: boolean;
// 	constructor(element: Element, mode: 'affordability' | 'repayment') {
// 		this.element = element;
// 		this.isAffordabilityMode = mode === 'affordability';
// 		// Affordability inputs
// 		this.inputMonthlyIncome = this.element.querySelector('input[name=monthly_income]');
// 		this.inputExpenses = this.element.querySelector('input[name=monthly_expenses]');
// 		this.inputTermAffordability = this.element.querySelector('input[name=term_months]');
// 		this.inputInterestAffordability = this.element.querySelector('input[name=interest_rate]');
// 		// Repayment inputs
// 		this.inputPurchasePrice = this.element.querySelector('input[name=purchase_price]');
// 		this.inputDeposit = this.element.querySelector('input[name=deposit_amount]');
// 		this.inputTermRepayment = this.element.querySelector('.js-term');
// 		this.inputInterestRepayment = this.element.querySelector('.js-interest_rate');
// 		// Outputs
// 		this.totalMonthlyRepayment = this.element.querySelector('.js-monthly-repayment');
// 		this.totalPurchasePrice = this.element.querySelector('.js-purchase-price');
// 		this.totalInterest = this.element.querySelector('.js-total-interest');
// 		this.termMonthsDisplay = this.element.querySelector('.js-term-months');
// 		this.interestRateDisplay = this.element.querySelector('.js-interest-rate');
// 		// Buttons
// 		this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
// 		this.buttonReset = this.element.querySelector('.js-calculator-reset');
// 		this.init();
// 	}
// 	init() {
// 		this.bindEvents();
// 		this.calculate();
// 	}
// 	bindEvents() {
// 		if (this.buttonCalculate) {
// 			this.buttonCalculate.addEventListener('click', () => this.calculate());
// 		}
// 		if (this.buttonReset) {
// 			this.buttonReset.addEventListener('click', () => this.reset());
// 		}
// 	}
// 	reset() {
// 		if (this.totalMonthlyRepayment) this.totalMonthlyRepayment.innerHTML = "-";
// 		if (this.totalPurchasePrice) this.totalPurchasePrice.innerHTML = "-";
// 		if (this.totalInterest) this.totalInterest.innerHTML = "-";
// 		if (this.interestRateDisplay) this.interestRateDisplay.innerHTML = "-";
// 		if (this.termMonthsDisplay) this.termMonthsDisplay.innerHTML = "-";
// 	}
// 	calculate() {
// 		if (this.isAffordabilityMode) {
// 			this.calculateAffordability();
// 		} else {
// 			this.calculateRepayment();
// 		}
// 	}
// 	calculateAffordability() {
// 		const income = parseFloat(this.inputMonthlyIncome?.value || '0');
// 		const term = parseFloat(this.inputTermAffordability?.value || '0');
// 		const interestRate = parseFloat(this.inputInterestAffordability?.value || '0');
// 		const monthlyRate = interestRate / 12 / 100;
// 		const maxInstallment = income * 0.5;
// 		const loanAmount = maxInstallment * ((1 - Math.pow(1 + monthlyRate, -term)) / monthlyRate);
// 		const monthlyInstallment = -this.PMT(monthlyRate, term, loanAmount);
// 		const formattedLoanAmount = this.roundFormatter(loanAmount, 0, true);
// 		const formattedMonthly = this.roundFormatter(monthlyInstallment, 0, true);
// 		if (this.totalPurchasePrice) this.totalPurchasePrice.innerHTML = formattedLoanAmount;
// 		if (this.totalMonthlyRepayment) this.totalMonthlyRepayment.innerHTML = formattedMonthly;
// 		if (this.interestRateDisplay) this.interestRateDisplay.innerHTML = interestRate.toFixed(2) + "%";
// 		if (this.termMonthsDisplay) this.termMonthsDisplay.innerHTML = `${term} months`;
// 	}
// 	calculateRepayment() {
// 		const purchasePrice = parseFloat(this.inputPurchasePrice?.value || '0');
// 		const deposit = parseFloat(this.inputDeposit?.value || '0');
// 		const term = parseFloat(this.inputTermRepayment?.value || '0');
// 		const interestRate = parseFloat(this.inputInterestRepayment?.value || '0');
// 		const monthlyRate = interestRate / 12 / 100;
// 		const loanAmount = purchasePrice - deposit;
// 		const monthlyInstallment = this.PMT(monthlyRate, term, -loanAmount);
// 		const formattedInstallment = this.roundFormatter(monthlyInstallment, 2, true);
// 		if (this.totalMonthlyRepayment) this.totalMonthlyRepayment.innerHTML = formattedInstallment;
// 		if (this.totalInterest) this.totalInterest.innerHTML = interestRate.toFixed(2) + "%";
// 		if (this.termMonthsDisplay) this.termMonthsDisplay.innerHTML = `${term} months`;
// 	}
// 	PMT(rate: number = 0, period: number = 0, value: number = 0, futurevalue: number = 0, type: number = 0): number {
// 		if (!futurevalue) futurevalue = 0;
// 		if (!type) type = 0;
// 		if (rate == 0) return -(value + futurevalue) / period;
// 		const pvif = Math.pow(1 + rate, period);
// 		let pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
// 		if (type === 1) {
// 			pmt /= (1 + rate);
// 		}
// 		return pmt;
// 	}
// 	roundFormatter(expr: number, decplaces: number, formatted: boolean = false): string {
// 		let str = '' + Math.round(expr * Math.pow(10, decplaces));
// 		while (str.length <= decplaces) {
// 			str = '0' + str;
// 		}
// 		const decpoint = str.length - decplaces;
// 		let valueFull: any = str.substring(0, decpoint);
// 		let valueDecimal: any = str.substring(decpoint);
// 		if (formatted) {
// 			valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
// 		}
// 		return valueFull + '.' + valueDecimal;
// 	}
// }



//////////////////
// WEBPACK FOOTER
// ./components-lesotho/calculator-lesotho-affordability-home-loan/calculator-lesotho-affordability-home-loan.component.ts
// module id = 793
// module chunks = 0